var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m9.901,15.335h2.2v2.2h-2.2v-2.2Z",
    fill: "#940404",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m12.087,14.237h-2.175c0-3.5,3.262-3.252,3.262-5.427-.00219-1.20112-.97388-2.17505-2.175-2.18-1.19234.0166-2.15566.97771-2.175,2.17h-2.174c.00138-2.40244,1.95006-4.34888,4.3525-4.3475,2.40244.00138,4.34888,1.95006,4.3475,4.3525h0c0,2.719-3.263,3.028-3.263,5.432Z",
    fill: "#940404",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "m11,2.221c4.8463.00236,8.77308,3.93298,8.77072,8.77927-.00236,4.8463-3.93297,8.77308-8.77927,8.77072-4.8463-.00236-8.77309-3.93298-8.77072-8.77927.00113-2.32586.92561-4.55613,2.57027-6.20072,1.6446-1.64969,3.87959-2.57478,6.209-2.57m0-2.221C4.92487,0,0,4.92487,0,11s4.92487,11,11,11,11-4.92487,11-11h0C22,4.92487,17.07513,0,11,0Z",
    fill: "#940404",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.04794bb8bd6a07e36e3e47eeba7fbe3e.svg";
export { ForwardRef as ReactComponent };